const config = require('./config.json');

config.products = [...config.medals.products, ...config.coins.products];
module.exports = config;

